import React, { useEffect, useState } from 'react'
import { Button, Image, Input, Section, Table } from '../../../components'
import { ICONS } from '../../../themes'
import NumberFormat from 'react-number-format'

// Constants
import { SubmitBid } from '../constants/SubmitBid'

// Helpers
import {
  formatNumberWithCommaN2Decimal,
  formatNumberWithCommaN4Decimal,
  STRING,
} from '../../../helpers'
import useIsMounted from '../../../components/useMounted'

const AuctionLeadingBid = ({
  itemsList,
  totalBidAmount,
  leading,
  eventData,
  setItemsList,
  bidDecrementIncrement,
  setTotalBidAmount,
  setSubmitBidStatus,
  toggleModal,
  setSubmitStatusId,
  itemBidHistory,
  setIsLoading,
  isHistoryChange,
}) => {
  const isMounted = useIsMounted()
  const [prevPriceValue, setPrevPriceValue] = useState([])
  const [disableDelButton, setDisableDelButton] = useState([
    false,
    false,
    false,
  ])
  const [disablePlusButton, setDisablePlusButton] = useState([
    false,
    false,
    false,
  ])
  const [showError, setShowError] = useState({ 0: false, 1: false, 2: false })

  useEffect(() => {
    ;(async () => {
      if (isMounted()) {
        let prevVal = []
        // console.log({ itemBidHistory, itemsList })
        if (itemBidHistory) {
          itemBidHistory.items.map((value, i) => {
            prevVal.push(value.total)
            itemsList.map((att, j) => {
              if (j === i) {
                att.total_price = value.total
                att.unit_price = value.price
              }
            })
            // console.log({ itemsList })
            setItemsList(itemsList)
          })
        } else {
          if (isHistoryChange) {
            itemsList.map(att => {
              att.total_price = 0
              att.unit_price = 0
            })
            setItemsList(itemsList)
          }
        }
        if (prevVal.length > 0) {
          // cal sum of prev value
          const sum = prevVal.reduce((a, b) => a + b, 0)
          setTotalBidAmount(sum)
        }
        console.log({ prevVal })
        setPrevPriceValue(prevVal)
      }
    })()
  }, [isMounted, itemsList, itemBidHistory])
  // }, [isMounted, itemBidHistory, itemsList, leading])

  const handlerSubmitBid = () => {
    setIsLoading(true)
    const result = checkValidateSubmitBid()
    setIsLoading(false)
    if (result) {
      setSubmitStatusId(1)
      setSubmitBidStatus(SubmitBid.SUBMIT_BIT_STATUS.SUCCESS)
      toggleModal('modals-submit-bid')
    } else {
      setSubmitBidStatus(SubmitBid.SUBMIT_BIT_STATUS.FAIL)
      toggleModal('modals-submit-bid-fail')
    }
  }

  const checkValidateSubmitBid = () => {
    let check = true
    // Condition is min bid / bid min
    const isBidDecrement = eventData.bid_decrement_increment
    const isMinBid = eventData.min_bid_decrement_increment
    let modBidDecrement = totalBidAmount % isBidDecrement
    let openingPrice = eventData.opening_price

    const typeReverse = eventData.bidding_type === 'Reverse'
    const totalMoreThanAndEqualOpeningPrice = totalBidAmount > openingPrice
    const totalMoreThanLeadingPrice = totalBidAmount >= leading.price
    const totalMoreThanMinBidNLeadingPrice =
      totalBidAmount > leading.price - isMinBid

    const typeForward = eventData.bidding_type === 'Forward'
    const totalLessThanAndEqualOpeningPrice = totalBidAmount < openingPrice
    const totalLessThanLeadingPrice = totalBidAmount <= leading.price
    const totalLessThanMinBidNLeadingPrice =
      totalBidAmount < isMinBid + leading.price
    const totalLessThanMinBid = totalBidAmount < isMinBid

    // Condition MinBid or IsBid
    const OpeningMinusTotal = openingPrice - totalBidAmount
    const TotalMinusOpening = totalBidAmount - openingPrice
    const LeadingPriceMinusTotal = leading.price - totalBidAmount
    const TotalMinusLeadingPrice = totalBidAmount - leading.price

    const isBidDecrement10Time = eventData.bid_decrement_increment * 10
    const isMinBid10Time = eventData.min_bid_decrement_increment * 10

    // Wrong Condition
    const reverseNTotalMoreOpening =
      typeReverse && totalMoreThanAndEqualOpeningPrice
    const reverseNTotalMoreLeading = typeReverse && totalMoreThanLeadingPrice

    const forwardNTotalLessOpening =
      typeForward && totalLessThanAndEqualOpeningPrice
    const forwardNTotalLessLeading = typeForward && totalLessThanLeadingPrice

    const isBidDecrementModNotZero = isBidDecrement && modBidDecrement !== 0

    const funcIsMinBid = () => {
      //Correct condition but bid decrement wrong
      if (totalLessThanMinBid) {
        if (typeReverse) {
          setSubmitStatusId(8)
          check = false
        } else if (typeForward) {
          setSubmitStatusId(9)
          check = false
        }
      }
      // else {
      //   checkIsMinBidMoreThan10Time()
      // }
    }

    // hide 10 x
    const checkIsMinBidMoreThan10Time = () => {
      const RVOpeningIsMoreThan10Time =
        !leading.price && OpeningMinusTotal > isMinBid10Time
      const FWOpeningIsMoreThan10Time =
        !leading.price && TotalMinusOpening > isMinBid10Time

      const RVLeadingIsMoreThan10Time =
        leading.price && LeadingPriceMinusTotal > isMinBid10Time
      const FWLeadingIsMoreThan10Time =
        leading.price && TotalMinusLeadingPrice > isMinBid10Time

      if (
        typeReverse &&
        (RVLeadingIsMoreThan10Time || RVOpeningIsMoreThan10Time)
      ) {
        setSubmitStatusId(12)
        check = false
      } else if (
        typeForward &&
        (FWLeadingIsMoreThan10Time || FWOpeningIsMoreThan10Time)
      ) {
        setSubmitStatusId(13)
        check = false
      }
    }

    // hide 10 x
    const checkIsBidMoreThan10Time = () => {
      const RVOpeningIsMoreThan10Time =
        !leading.price && OpeningMinusTotal > isBidDecrement10Time
      const FWOpeningIsMoreThan10Time =
        !leading.price && TotalMinusOpening > isBidDecrement10Time

      const RVLeadingIsMoreThan10Time =
        leading.price && LeadingPriceMinusTotal > isBidDecrement10Time
      const FWLeadingIsMoreThan10Time =
        leading.price && TotalMinusLeadingPrice > isBidDecrement10Time

      if (
        typeReverse &&
        (RVLeadingIsMoreThan10Time || RVOpeningIsMoreThan10Time)
      ) {
        setSubmitStatusId(10)
        check = false
      } else if (
        typeForward &&
        (FWLeadingIsMoreThan10Time || FWOpeningIsMoreThan10Time)
      ) {
        setSubmitStatusId(11)
        check = false
      }
    }

    const funcIsBidDecrementIncrement = () => {
      //Correct condition but bid decrement wrong
      if (typeReverse) {
        setSubmitStatusId(6)
      } else if (typeForward) {
        setSubmitStatusId(7)
      }
      check = false
    }

    if (leading.price) {
      if (reverseNTotalMoreLeading) {
        setSubmitStatusId(4)
        check = false
      } else if (forwardNTotalLessLeading) {
        setSubmitStatusId(5)
        check = false
      } else if (isBidDecrementModNotZero) {
        funcIsBidDecrementIncrement()
      } else if (isMinBid) {
        if (typeReverse && totalMoreThanMinBidNLeadingPrice) {
          setSubmitStatusId(8)
          check = false
        } else if (typeForward && totalLessThanMinBidNLeadingPrice) {
          setSubmitStatusId(9)
          check = false
        } else {
          funcIsMinBid()
        }
      }
      // else if (isBidDecrement) {
      //   checkIsBidMoreThan10Time()
      // }
    } else {
      if (reverseNTotalMoreOpening) {
        setSubmitStatusId(2)
        check = false
      } else if (forwardNTotalLessOpening) {
        setSubmitStatusId(3)
        check = false
      } else if (isBidDecrementModNotZero) {
        funcIsBidDecrementIncrement()
      } else if (isMinBid) {
        funcIsMinBid()
      }
      // else if (isBidDecrement) {
      //   checkIsBidMoreThan10Time()
      // }
    }
    return check
  }

  const calSum = (i, val) => {
    const arrSum = itemsList.reduce(
      (acc, { total_price }) => acc + total_price,
      0
    )
    setTotalBidAmount(arrSum)

    // update unit price and total price
    const temp = itemsList
    // temp[i].total_price = val || val !== undefined ? val : 0
    temp[i].unit_price = (val / Number(temp[i].req_amount)).toFixed(4)
    setItemsList(temp)
  }

  const findItemValueIsZero = myArray => {
    for (let i = 0; i < myArray.length; i++) {
      if (myArray[i].total_price <= 0) {
        return true
      }
    }
  }

  const findIsValueError = () => {
    let array = Object.values(showError)
    if (array && array.includes(true)) {
      return true
    }
  }

  const renderSummaryTitle = () => {
    return (
      <Section className="bid-summary-title">
        <div className="title">Leading Bid:</div>
        <div className="detail">
          <b>
            {leading && formatNumberWithCommaN2Decimal(leading.price)}{' '}
            {eventData && eventData.currency}
          </b>
        </div>
      </Section>
    )
  }

  const renderSummaryList = () => {
    const disablePlus = (item, i) => {
      const isReverse =
        eventData.bidding_type === SubmitBid.BIDDING_TYPE.REVERSE
      const totalMorePrevTotal = item && item.total_price > prevPriceValue[i]
      const isDisable = isReverse && totalMorePrevTotal
      setStateDisable('plus', i, isDisable)
      return isDisable
    }

    const disableDelete = (item, i) => {
      const isForward =
        eventData.bidding_type === SubmitBid.BIDDING_TYPE.FORWARD
      const totalLessPrevTotal = item && item.total_price < prevPriceValue[i]
      const isDisable = isForward && totalLessPrevTotal
      setStateDisable('delete', i, isDisable)
      return isDisable
    }

    const setStateDisable = (type, i, value) => {
      if (type === 'delete') {
        setDisableDelButton(prevState => ({
          ...prevState,
          [i]: value,
        }))
      } else if (type === 'plus') {
        setDisablePlusButton(prevState => ({
          ...prevState,
          [i]: value,
        }))
      }
    }

    const checkDisablePlusButton = item => {
      // last_value = last value first can be plus
      const last_value = 10000000000 - bidDecrementIncrement
      return item.total_price ? item.total_price : 0 <= last_value
    }

    const checkDisableDeleteFunc = item => {
      // last_value = last value first can be plus
      return (
        Number(item.total_price) === 0 ||
        item.total_price === undefined ||
        item.total_price === ''
      )
    }

    const plusFunc = (item, i) => {
      const isDisable = disablePlus(item, i)
      const isButtonDisable = checkDisablePlusButton(item)
      if (!isDisable && isButtonDisable) {
        setStateDisable('plus', i, false)
        setStateDisable('delete', i, false)
        item.total_price = item.total_price ? item.total_price : 0
        item.total_price = Number(item.total_price) + bidDecrementIncrement
        calSum(i, item.total_price)
      }
    }

    const deleteFunc = (item, i) => {
      const isDisable = disableDelete(item, i)
      if (!isDisable) {
        setStateDisable('plus', i, false)
        setStateDisable('delete', i, false)
        item.total_price = item.total_price ? item.total_price : 0
        if (
          Number(item.total_price) > 0 &&
          Number(item.total_price) < bidDecrementIncrement
        ) {
          item.total_price = 0
        } else if (Number(item.total_price) >= bidDecrementIncrement) {
          item.total_price = Number(item.total_price) - bidDecrementIncrement
        }
        calSum(i, item.total_price)
      }
    }

    const checkDisableButtonByTyping = (value, i) => {
      const isReverse =
        eventData.bidding_type === SubmitBid.BIDDING_TYPE.REVERSE
      const totalMorePrevTotal = value > prevPriceValue[i]
      const isPlusDisable = isReverse && totalMorePrevTotal

      const isForward =
        eventData.bidding_type === SubmitBid.BIDDING_TYPE.FORWARD
      const totalLessPrevTotal = value < prevPriceValue[i]
      const isDeleteDisable = isForward && totalLessPrevTotal

      if (isPlusDisable || isDeleteDisable) {
        setShowError(prevState => ({
          ...prevState,
          [i]: isPlusDisable ? isPlusDisable : isDeleteDisable,
        }))
        setStateDisable(
          isPlusDisable ? 'plus' : 'delete',
          i,
          isPlusDisable ? isPlusDisable : isDeleteDisable
        )
      } else {
        setShowError(prevState => ({
          ...prevState,
          [i]: false,
        }))
        setStateDisable('plus', i, false)
        setStateDisable('delete', i, false)
      }
      calSum(i, value)
    }

    const renderBiddingEachValueError = i => {
      return (
        showError[i] && (
          <Section className="message">
            {`Total price for this item cannot ${
              eventData &&
              eventData.bidding_type === SubmitBid.BIDDING_TYPE.REVERSE
                ? 'exceed'
                : 'be lowered than '
            } the previous bid amount.`}
            {/* {formatNumberWithCommaN2Decimal(prevPriceValue[i])} */}
          </Section>
        )
      )
    }

    return (
      <Section className="bid-summary-list">
        <Section className="table-header-freeze-wrapper">
          <Table className="split-row-color">
            <Table.THEAD>
              <Table.TR className="header">
                <Table.TH className="no" id="no">
                  No.
                </Table.TH>
                <Table.TH className="item-name" id="item-name">
                  ITEM NAME
                </Table.TH>
                <Table.TH className="description" id="description">
                  DESCRIPTION
                </Table.TH>
                <Table.TH className="quantity" id="quantity">
                  QUANTITY
                </Table.TH>
                <Table.TH className="uom" id="uom">
                  UOM
                </Table.TH>
                <Table.TH className="unit-price" id="unit-price">
                  UNIT PRICE ({eventData && eventData.currency})
                </Table.TH>
                <Table.TH className="total-price center" id="total-price">
                  TOTAL PRICE ({eventData && eventData.currency})
                </Table.TH>
              </Table.TR>
            </Table.THEAD>
            <Table.TBODY className="list">
              {itemsList &&
                itemsList.length > 0 &&
                itemsList.map((item, i) => {
                  return (
                    <Table.TR key={`${item.name}_${i}`}>
                      <Table.TD className="no">{i + 1}</Table.TD>
                      <Table.TD className="item-name" id="item-name">
                        <Section className="item">{item.name}</Section>
                      </Table.TD>
                      <Table.TD className="description" id="description">
                        <Section className="description-item">
                          {item.description || '-'}
                        </Section>
                      </Table.TD>
                      <Table.TD className="quantity" id="quantity">
                        {/* 2 decimal */}
                        {formatNumberWithCommaN2Decimal(item.req_amount)}
                      </Table.TD>
                      <Table.TD className="uom" id="uom">
                        {item.uom}
                      </Table.TD>
                      <Table.TD className="unit-price" id="unit-price">
                        {item.unit_price === 0
                          ? '0.0000'
                          : formatNumberWithCommaN4Decimal(item.unit_price)}
                      </Table.TD>
                      <Table.TD className="total-price" id="total-price">
                        <Section className="form-group">
                          <Section
                            className={`input-total-price ${
                              (!item.total_price || showError[i]) && 'is-error'
                            }`}
                          >
                            <NumberFormat
                              id={i}
                              customInput={Input}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              min={0}
                              name="bid_price"
                              isAllowed={values => {
                                const { value } = values
                                return (
                                  value.charAt(0) !== '-' &&
                                  value <= 10000000000
                                )
                              }}
                              /* 2 decimal */
                              // value={item.total_price ? item.total_price : ''}
                              value={item.total_price}
                              placeholder={'0.00'}
                              onValueChange={e => {
                                let { floatValue } = e
                                item.total_price = floatValue
                                checkDisableButtonByTyping(floatValue, i)
                              }}
                            />
                          </Section>
                          <Button
                            className="link"
                            style={
                              checkDisableDeleteFunc(item, i) ||
                              disableDelButton[i]
                                ? { cursor: 'default' }
                                : { cursor: 'pointer' }
                            }
                            onClick={() => deleteFunc(item, i)}
                          >
                            <Image
                              src={ICONS['icon-trapezoid-delete.svg']}
                              className={`
                                    icon-trapezoid ${
                                      checkDisableDeleteFunc(item, i) ||
                                      disableDelButton[i]
                                        ? 'disable-icon'
                                        : ''
                                    }`}
                            />
                          </Button>
                          <Button
                            className="link"
                            style={
                              !checkDisablePlusButton(item) ||
                              disablePlusButton[i]
                                ? { cursor: 'default' }
                                : { cursor: 'pointer' }
                            }
                            onClick={() => plusFunc(item, i)}
                          >
                            <Image
                              src={ICONS['icon-trapezoid-plus.svg']}
                              className={`
                                    icon-trapezoid ${
                                      !checkDisablePlusButton(item) ||
                                      disablePlusButton[i]
                                        ? 'disable-icon'
                                        : ''
                                    }`}
                            />
                          </Button>
                        </Section>
                        {renderBiddingEachValueError(i)}
                        {!item.total_price && (
                          <Section className="message">
                            {STRING.INVALID}
                          </Section>
                        )}
                      </Table.TD>
                    </Table.TR>
                  )
                })}
            </Table.TBODY>
          </Table>
        </Section>
      </Section>
    )
  }

  const renderSubmitBid = () => {
    return (
      <Section className="submit-bid">
        <Section className="total-amount">
          <b>
            {/* 2 decimal */}
            Total Bidding Amount :{' '}
            {formatNumberWithCommaN2Decimal(totalBidAmount)}{' '}
            {eventData && eventData.currency}
          </b>
        </Section>
        <Button
          className="btn-submit"
          disabled={
            !totalBidAmount ||
            findItemValueIsZero(itemsList) ||
            findIsValueError(showError)
          }
          onClick={() => {
            handlerSubmitBid()
          }}
        >
          SUBMIT BID
        </Button>
      </Section>
    )
  }
  return (
    <>
      {renderSummaryTitle()}
      {renderSummaryList()}
      {renderSubmitBid()}
    </>
  )
}

export default AuctionLeadingBid
